/**
 * @file InputNumberOnly
 * @author pierre-michel@on-running.com
 *
 * @module utility/input-number-only
 *
 * Allow only numbers to be entered in a specific input.
 * Add the class 'js-number-only' to an input to add the event on page load.
 */
import { onDOMContentLoaded } from '@/helpers/event'
;(function () {
  function allowNumberOnly(event) {
    const key = event.keyCode || event.which
    const numbers = key >= 48 && key <= 57
    const backspace = key === 8
    const tab = key === 9
    const enter = key === 13

    if (numbers || backspace || tab || enter) {
      return true
    } else {
      event.preventDefault()
      return false
    }
  }
  // Clean the input afterwards to be sure no accented character has been added
  // or content pasted
  const cleanInputValue = element => {
    element.value = element.value.replace(/\D+/g, '')
  }

  On.InputNumberOnly = function (input) {
    cleanInputValue(input)
    input.addEventListener('keypress', allowNumberOnly)

    // Clean the input afterwards to be sure no accented character has
    // been added or content pasted
    input.addEventListener('keyup', () => cleanInputValue(input))

    // show number keypad on mobile instead of whole keyboard
    input.type = 'tel'
  }

  const init = () => {
    document.querySelectorAll('.js-number-only').forEach(input => {
      On.InputNumberOnly(input)
    })
  }
  onDOMContentLoaded().then(init)
})()
